















	import { Vue, Component, Prop } from "../../Infrastructure/CorBase/CoreBase";

	@Component
	export default class BaseTLProgress extends Vue {
        @Prop({ type: Number, required: true, default: 0 }) progress!: number; //hodnota progresu
		@Prop({ type: String, required: false, default: "" }) label?: string; //hlavní popis
        @Prop({ type: Boolean, required: false, default: false }) showPercent?: boolean; //zobrazeni procent

		//načtení stylu
		get inputClass() {
			return {				
				"col-sm-3 ": true,//puvodni
				"labelDetailForm ": true,			
			};
		}

		get variant() {
			if (this.progress < 25) {
				return 'danger';
			}
			else if (this.progress < 50) {
				return 'warning';
			}
            else if (this.progress < 75) {
                return 'info';
			}
            else  {
                return 'success';
            }

        }

	}
